
import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { GetResponse } from "@ontime/types";
import { AppointmentReportDto, AppointmentReportRequest, DebtorClientsDto, DebtorClientsRequest, PaymentReportDto, PaymentReportRequest, PaymentsByLoyaltyDto, PaymentsByLoyaltyRequest, ReferralClientsDto, ReferralClientsRequest } from "@ontime/types";


const API_URL = ApiURL() + 'Report';

class ReportService {

    GetPaymentReport(input: PaymentReportRequest) {
        return axios.get<GetResponse<PaymentReportDto[]>>(API_URL + "/GetPaymentReport", {
            params: input,
            headers: AuthHeader(),
        });
    }

    GetPaymentReportExcel(input: PaymentReportRequest) {
        return axios.get<Blob>(API_URL + "/GetPaymentReportExcel", {
            params: input,
            headers: AuthHeader(),
            responseType: 'blob',
        });
    }

    GetPaymentsByLoyalty(input: PaymentsByLoyaltyRequest) {
        return axios.get<GetResponse<PaymentsByLoyaltyDto[]>>(API_URL + "/GetPaymentsByLoyalty", {
            params: input,
            headers: AuthHeader(),
        });
    }

    GetPaymentsByLoyaltyExcel(input: PaymentsByLoyaltyRequest) {
        return axios.get<Blob>(API_URL + "/GetPaymentsByLoyaltyExcel", {
            params: input,
            headers: AuthHeader(),
            responseType: 'blob',
        });
    }

    GetAppointmentReport(input: AppointmentReportRequest) {
        return axios.get<GetResponse<AppointmentReportDto[]>>(API_URL + "/GetAppointmentReport", {
            params: input,
            headers: AuthHeader(),
        });
    }

    GetAppointmentReportExcel(input: AppointmentReportRequest) {
        return axios.get<Blob>(API_URL + "/GetAppointmentReportExcel", {
            params: input,
            headers: AuthHeader(),
            responseType: 'blob',
        });
    }

    GetReferralClients(input: ReferralClientsRequest) {
        return axios.get<GetResponse<ReferralClientsDto[]>>(API_URL + "/GetReferralClients", {
            params: input,
            headers: AuthHeader(),
        });
    }

    GetReferralClientsExcel(input: ReferralClientsRequest) {
        return axios.get<Blob>(API_URL + "/GetReferralClientsExcel", {
            params: input,
            headers: AuthHeader(),
            responseType: 'blob',
        });
    }

    GetDebtorClients(input: DebtorClientsRequest) {
        return axios.get<GetResponse<DebtorClientsDto[]>>(API_URL + "/GetDebtorClients", {
            params: input,
            headers: AuthHeader(),
        });
    }

    GetDebtorClientsExcel(input: DebtorClientsRequest) {
        return axios.get<Blob>(API_URL + "/GetDebtorClientsExcel", {
            params: input,
            headers: AuthHeader(),
            responseType: 'blob',
        });
    }

}

export default new ReportService();